import { jsx as _jsx } from "react/jsx-runtime";
import { classDerivedDeviceEnabledTypes } from '@iotv/datamodel';
import { UserClassName } from '@iotv/datamodel-core';
import { AppValueTypes } from '@iotv/iotv-v3-types';
import { getViewDefintionFromObject } from '../../../../components/factories/AttributeDefinitions';
import { useApplicationDataQueries } from '../../../../hooks/useApplicationDataQueries';
import { useMostProximateCustomer } from '../../../../hooks/useMostProximateCustomer';
import { CustomerDetailCard } from './DetailCard/CustomerDetailCard';
import DetailCard from './DetailCard/DetailCard'; //v2
import { UserDetailCard } from './DetailCard/UserDetailCard';
const debug = process.env.REACT_APP_DEBUG && false;
export const genericObjectDetailCardViewDefinition = {
    name: {
        key: 'name',
        label: 'Name',
        type: AppValueTypes.STRING,
        editable: true,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    description: {
        key: 'description',
        label: 'Description',
        type: AppValueTypes.STRING,
        editable: true,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    type: {
        key: 'type',
        label: 'Type',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
/** Mutate transactionfunctions.saveObject if it is required to, for example, link at save */
export const ObjectDetailCard = ({ title, matchedPrimary, contextObjectForDetailCard, postTransactionCallback, contextObject, transactionFunctions, subContextCustomer, definedEntriesOnlyOpt, viewDefinition: viewDefinitionIn, viewDefinitionAcceptance, viewDefinitionAddition, userFunctions, allowedActions, showContextSubCard, contextUser, isSmallView, }) => {
    debug && console.log('ObjectDetailCard got matchedPrimary', matchedPrimary);
    debug && console.log(`ObjectDetailCard for ${matchedPrimary.type} with allowed actions`, allowedActions);
    const { isNewObject } = useApplicationDataQueries({ item: matchedPrimary });
    const mostProximateCustomer = useMostProximateCustomer({ item: isNewObject ? (contextObject ?? matchedPrimary) : matchedPrimary });
    let viewDefinition = viewDefinitionIn ?? getViewDefintionFromObject(matchedPrimary) ?? genericObjectDetailCardViewDefinition;
    if (viewDefinitionAddition)
        Object.assign(viewDefinition, viewDefinitionAddition);
    if (viewDefinitionAcceptance) {
        viewDefinition = Object.keys(viewDefinition)
            .filter((key) => viewDefinitionAcceptance.includes(key))
            .sort((a, b) => {
            return viewDefinitionAcceptance.indexOf(a) - viewDefinitionAcceptance.indexOf(b);
        })
            .reduce((obj, key) => {
            obj[key] = viewDefinition[key];
            return obj;
        }, {});
    }
    /** if new user show EDM quick set up fields */
    // const showVariantControls =
    //   matchedPrimary.type === 'User' &&
    //   !!(initialEditMode !== undefined && [ComponentMode.CREATE, ComponentMode.EDIT, ComponentMode.ALWAYSEDIT].includes(initialEditMode))
    // debug && console.log(`ObjectDetailCard modes`, { type: matchedPrimary.type, initialEditMode: initialEditMode !== undefined && ComponentMode[ initialEditMode ], showVariantControls});
    if (classDerivedDeviceEnabledTypes.includes(matchedPrimary.type)) {
        // Mute TZ in entity
        delete viewDefinition.tz;
    }
    const detailCardProps = {
        title,
        matchedPrimary,
        contextObjectForDetailCard,
        contextObject,
        postTransactionCallback,
        subContextCustomer,
        mostProximateCustomer,
        viewDefinition,
        transactionFunctions,
        //editMode: initialEditMode,
        definedEntriesOnlyOpt,
        //deletable,
        allowedActions,
        userFunctions,
        /*showVariantControls,*/
        isNewObjectIn: isNewObject ?? undefined,
        showContextSubCard,
    };
    debug && console.log('ObjectDetailCard: rendering detail card with type', matchedPrimary.type, detailCardProps);
    // TODO: (ADH) additional props in UserDetailCard are holdovers until ObjectCardProps is updated to ThingViewSingleItemProps
    switch (matchedPrimary.type) {
        case UserClassName:
            return _jsx(UserDetailCard, { ...detailCardProps, contextUser: contextUser, isSmallView: isSmallView ?? false });
        case 'Customer':
            return _jsx(CustomerDetailCard, { ...detailCardProps });
        default:
            return _jsx(DetailCard, { ...detailCardProps });
    }
};
